import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import {
    buildTableSql,
    SchemaPropertyType,
    type SchemaProperty,
    type StorageDatabaseSchema,
} from "@vesta/vos-types/modules/platformLevel/storageDatabases/domain/StorageDatabaseSchema";

export const ottopilotEventContainersWorkspaceCapabilityDefaultColumns: Record<string, Omit<SchemaProperty, "id">> = {
    created_at: {
        defaultValue: null,
        displayName: "Created at",
        internalName: "createdAt",
        required: true,
        type: SchemaPropertyType.timestamp,
    },
    created_by: {
        defaultValue: null,
        displayName: "Created by",
        internalName: "createdBy",
        required: true,
        type: SchemaPropertyType.uuid,
    },
    id: {
        defaultValue: null,
        displayName: "Id",
        internalName: "id",
        required: true,
        type: SchemaPropertyType.uuid,
    },
    notes: {
        defaultValue: null,
        displayName: "Notes",
        internalName: "notes",
        required: false,
        type: SchemaPropertyType.json,
    },
    revision_id: {
        defaultValue: null,
        displayName: "Revision id",
        internalName: "revisionId",
        required: true,
        type: SchemaPropertyType.uuid,
    },
    status: {
        defaultValue: null,
        displayName: "Status",
        internalName: "status",
        required: true,
        type: SchemaPropertyType.uuid,
    },
    template_id: {
        defaultValue: null,
        displayName: "Template id",
        internalName: "templateId",
        required: true,
        type: SchemaPropertyType.uuid,
    },
    updated_at: {
        defaultValue: null,
        displayName: "Updated at",
        internalName: "updatedAt",
        required: true,
        type: SchemaPropertyType.timestamp,
    },
    updated_by: {
        defaultValue: null,
        displayName: "Updated by",
        internalName: "updatedBy",
        required: true,
        type: SchemaPropertyType.uuid,
    },
};

export function buildOttopilotEventContainerTablesProvisionSql({
    eventContainerTemplateId,
    schema,
    workspaceId,
}: {
    eventContainerTemplateId: Uuid;
    schema: StorageDatabaseSchema;
    workspaceId: Uuid;
}): Array<string> {
    const {createQuery: createEventContainerTableQuery} = buildTableSql({
        primaryKeyColumnName: "id",
        schema: schema,
        templateId: eventContainerTemplateId,
        workspaceId: workspaceId,
    });
    const {createQuery: createEventContainerLogTableQuery} = buildTableSql({
        includeUniqueConstraints: false,
        primaryKeyColumnName: "revision_id",
        schema: schema,
        tableName: `${eventContainerTemplateId}_logs`,
        templateId: eventContainerTemplateId,
        workspaceId: workspaceId,
    });

    return [
        createEventContainerTableQuery,
        createEventContainerLogTableQuery,
    ];
}
